import {
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
} from '@chakra-ui/react';
import React from 'react';

export const UploadModal = ({
  isOpen,
  onClose,
  modalHeaderText,
  children,
}: {
  children: React.ReactNode;
  isOpen: boolean;
  onClose: () => void;
  modalHeaderText: string;
}) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} size="lg">
      <ModalOverlay />
      <ModalContent padding="20px" width="auto" minW="550px">
        <ModalHeader>{modalHeaderText}</ModalHeader>
        <ModalCloseButton />
        <ModalBody>{children}</ModalBody>
      </ModalContent>
    </Modal>
  );
};
